module.exports = function getResource(label, vars = []) {
    let resources = {
        free: 'GRATUIT',
        billedMonthly: 'facturé par mois'
    };
    return resources[label];
};
